export enum EnrolmentActionsEnums {
	EMPTY = '',
	MOVE_TO_HISTORY = 'moveToHistory',
	MOVE_TO_ORGANISATION = 'moveToOrganisation'
}
